import axios from 'axios';
import { baseUrl, HttpMethods } from '../../../../base';
import {
  IDeleteProjectEventService,
  IGetProjectEventsService,
  IGetProjectEventsServiceRes,
  IPatchProjectEventService,
  IPostProjectEventService,
  IPostProjectEventServiceRes,
} from './types';

export async function getProjectEvents({
  params,
  projectId,
}: IGetProjectEventsService): Promise<IGetProjectEventsServiceRes> {
  const res = await axios.request<IGetProjectEventsServiceRes>({
    method: HttpMethods.GET,
    url: `${baseUrl.SHERPA}/projects/${projectId}/schedules`,
    params,
  });
  return res.data;
}

export async function postProjectEvent({
  data,
  projectId,
}: IPostProjectEventService): Promise<IPostProjectEventServiceRes> {
  const res = await axios.request<IPostProjectEventServiceRes>({
    method: HttpMethods.POST,
    url: `${baseUrl.SHERPA}/projects/${projectId}/schedules`,
    data,
  });
  return res.data;
}

export async function patchProjectEvent({
  projectId,
  eventId,
  data,
}: IPatchProjectEventService) {
  const res = await axios.request({
    method: HttpMethods.PATCH,
    url: `${baseUrl.SHERPA}/projects/${projectId}/schedules/${eventId}`,
    data,
  });
  return res.data;
}

export async function deleteProjectEvent({
  projectId,
  eventId,
}: IDeleteProjectEventService) {
  const res = await axios.request({
    method: HttpMethods.DELETE,
    url: `${baseUrl.SHERPA}/projects/${projectId}/schedules/${eventId}`,
  });
  return res.data;
}
